/**
 * localStorage seguro para WebViews restringidos (Instagram/Facebook en Android).
 * Si el almacenamiento está bloqueado o lanza SecurityError, usa memoria.
 */
const memory = {};

function getLocalStorage() {
	try {
		if (typeof window === "undefined" || !window.localStorage) return null;
		const key = "__guia_storage_test__";
		window.localStorage.setItem(key, "1");
		window.localStorage.removeItem(key);
		return window.localStorage;
	} catch (_) {
		return null;
	}
}

const storage = getLocalStorage();

export const safeStorage = {
	getItem(key) {
		try {
			if (storage) return storage.getItem(key);
		} catch (_) {}
		return Object.prototype.hasOwnProperty.call(memory, key) ? memory[key] : null;
	},
	setItem(key, value) {
		const next = String(value);
		try {
			if (storage) {
				storage.setItem(key, next);
				return;
			}
		} catch (_) {}
		memory[key] = next;
	},
	removeItem(key) {
		try {
			if (storage) storage.removeItem(key);
		} catch (_) {}
		delete memory[key];
	},
};
